<template>
  <div id="wrap" class="nisc-wrap" >
    <div id="krds-skip-link">
      <a href="#container">본문 바로가기</a>
    </div>
    <header id="krds-header" style="border: none;">
      <LayoutTop ref="topMenu" :isPCMenuOpen.sync="isPCMenuOpen"/>
    </header>
    <Main v-if="$route.path=='/'" />
    <div v-if="$route.path!='/'" >
        <div id="container">
          <div class="inner in-between">
            <!-- 사이드바영역-->
            <LayoutLeft />
            <!-- 컨텐츠영역 -->
            <div class="contents" v-show="true">
              <nav class="krds-breadcrumb-wrap align-right" aria-label="현재 경로" id="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="home" ><a href="/" class="txt">홈</a></li>
                      <li v-if="subMenuBreadcrumb != null && subMenuBreadcrumb != ''" class="breadCrumbBr1" ><a class="txt">{{$sanitize($t(subMenuBreadcrumb))}}</a></li>
                      <li v-if="subMenuTitle != null && subMenuTitle != ''" class="breadCrumbBr2"><a class="txt">{{$sanitize($t(subMenuTitle))}}</a></li>
                      <li v-if="subMenuBreadcrumbTitle != null && subMenuBreadcrumbTitle != ''" class="breadCrumbBr3"><a class="txt">{{$sanitize($t(subMenuBreadcrumbTitle))}}</a></li>
                    </ol>
              </nav>
              <section class="content-wrap">
                  <h2 class="section-title lg"  v-html="$sanitize($t(subMenuTitle))"></h2>
                  <router-view />
              </section>
            </div>
          </div>
        </div>
    </div>
    <LayoutFooter :organ="organ" :snsLinkList="snsLinkList"/>
    <div class="gnb-backdrop" :class="{ active: isPCMenuOpen }"></div>
    <div class="floating-menu">
      <button type="button" class="go-top__btn" @click="doScrollTop"></button>
    </div>
    <template v-if="$route.path =='/'">
      <template v-for="(item, index) in layerPopupList">
        <div v-if="doCookie(item)" class="layer-popup-main" :style="item.layerStyle != null? item.layerStyle :doLayerStyle(item)" :key="index">
          <div v-html="item.content" class="layerCont"></div>
          <div class="today-close">
            <ul>
              <input type="checkbox" v-if="item.nextCloseYn == 'Y'" v-model="item.layerNextCloseYn" true-value="Y" false-value="N" >
              <label for="next_close" v-if="item.nextCloseYn == 'Y'">{{ item.nextCloseDd }}{{$t('nextCloseDdText')}}</label>
              <input type="button" value="닫기" @click="doNextClose(item, item.layerNextCloseYn)" class="ct_bt01" >
            </ul>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import LayoutTop from '@/views/layouts/LayoutTop'
import LayoutFooter from '@/views/layouts/LayoutFooter'
import LayoutLeft from '@/views/layouts/LayoutLeft'
import Main from '@/views/Main'

export default {
  metaInfo() {
    return {
      title: this.metaInfo.title,
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: this.metaInfo.ogTitle }, 
        { property: 'og:url', content: this.metaInfo.ogUrl },
        { property: 'og:description', content: this.metaInfo.ogDescription },
        { property: 'og:image', content: this.metaInfo.ogImage },
      ]
    }
  },
  components: {
    LayoutTop,
    LayoutLeft,
    LayoutFooter,
    Main,
  },
  computed: {
    ...mapGetters([
      'subMenuTitle',
      'subMenuBreadcrumb',
      'subMenuBreadcrumbTitle',
      'popupInfo',
      'metaInfo'
    ]),
    breadcrumbItem() {
    return this.topMenu.find(menu => menu.menuNm === this.subMenuBreadcrumb) || {};
    }
  },
  created() {
    this.doMainContent();
  },
  data() {
    return {
      headClass: ['over'],
      topBanner: {},
      showTopBanner: false,
      layerPopupList: [],
      windowPopupList: [],
      topLinkList:[],
      lastScroll: 0, 
      headerHidden: false,
      snsLinkList:[],
      organ: {},
      isPCMenuOpen: false
    }  
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    doScrollTop() {
      window.scrollTo({top:0, behavior:'smooth'});
    },
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > 50) {
          document.body.classList.add("scroll");
        } else {
          document.body.classList.remove("scroll");
        }
      const wrap = document.getElementById("wrap");
      if (!wrap) return;

      const currentScroll = window.scrollY;

      // 스크롤 방향 감지
      if (currentScroll > this.lastScroll) {
        wrap.classList.add("scroll-down");
        wrap.classList.remove("scroll-up");
      } else if (currentScroll < this.lastScroll) {
        wrap.classList.add("scroll-up");
        wrap.classList.remove("scroll-down");
      }

      this.lastScroll = currentScroll;
    },
    doScrollTop() {
      window.scrollTo({top:0, behavior:'smooth'});
    },
    doMainContent() {
      this.$tran('/site/external/main/selectMainContent', '').then(response => {
        this.topBanner = response.data.topList[0];
        this.topLinkList = response.data.topLinkList;
        this.layerPopupList = response.data.layerPopupList;
        this.windowPopupList = response.data.windowPopupList;
        this.snsLinkList = response.data.snsLinkList;
        this.organ = response.data.organ;

        this.$nextTick(() => {
          const bannerNo = this.topBanner?.bannerNo;
          if(bannerNo != null && bannerNo != '') {
            this.showTopBanner = true;
          }

          if(this.windowPopupList != null && this.windowPopupList.length > 0 && this.$route.path =='/') {
            this.doWindowPopup();
          }
        })
      })
    },
    doCookie(item) {
      const data = this.$cookies.get(item.popupNo);

      if(data != null) {
        return false;
      }
      return true;
    },
    doNextClose(item, layerNextCloseYn) {
      if(layerNextCloseYn == 'Y') {
        this.$cookies.set(item.popupNo, 'Y', `${item.nextCloseDd}d`);
      }
      
      this.doLayerClose(item);
    },
    doLayerClose(item) {
      item.layerStyle.display = 'none';
    },
    doLayerStyle(item) {
      const width = item.widthPixel;
      const height = item.heightPixel;
      const left = item.leftPixel;
      const top = item.topPixel;

      const layerStyle = {
        backgroundImage: `url(${encodeURI(item?.imgUrl)})`,
        width: `${width}px`,
        height: `${Number(height)+30}px`,
        left: `${left}px`,
        top: `${top}px`,
        display: 'block',
        'background-size': 'contain',
        backgroundRepeat: 'no-repeat'
      }

      this.$set(item, 'layerStyle', layerStyle);
    },
    doWindowPopup() {
      for(let i=0; i < this.windowPopupList.length; i++) {
        const getCookie = this.doCookie(this.windowPopupList[i]);

        if(getCookie) {
          const data = this.windowPopupList[i]
          const popupNo = data.popupNo;
          const imgUrl = data.imgUrl;
          const width = data.widthPixel;
          let height = data.heightPixel;
          const left = data.leftPixel;
          const top = data.topPixel;
          const content = data.content;
          const nextCloseDd = data.nextCloseDd;
          const nextCloseYn = data.nextCloseYn;

          
          if(height != null && typeof height == 'string'){
            const intData = height.replaceAll(/(-)[^\d.]/gi, '')
            if(intData != null && intData != ''){
              height = (parseFloat(intData) + 30) + height.replaceAll(/[-\d.]/gi,'')
            }
          }
          
          const win = window.open('', popupNo, `location=no,width=${width},height=${height},top=${top},left=${left}`);

          if(win.document.querySelector('.newPopupDiv') != null) {
            win.document.querySelector('.newPopupDiv').remove();
            win.document.querySelector('.popup').remove();
          }

          if(win.document.querySelector('.footer') != null) {
            win.document.querySelector('.footer').remove();
          }

          if(win.document.querySelector('script') != null) {
            win.document.querySelector('script').remove();
          }

          if(win.document.querySelector('style') != null) {
            win.document.querySelector('style').remove();
          }
          
          const htmlTag = `
                    <style>
                      body {
                        margin: 0px;
                      }

                      img {
                        width: 100%;
                      }

                      p br{
                        display:none;
                      }

                      table, pre,div {
                        color: #575757; 
                        font-size: 1em;
                      }

                      .newPopupDiv {
                        height: calc(100% - 30px);
                        width: 100%;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-image: url(${encodeURI(imgUrl)});
                      }

                      #next_close {
                        margin-top: 9px;
                      }

                      div.popup {
                        clear: both;
                        position: relative;
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        text-align: right;
                      }

                      div.popup .ct_bt01 {
                        margin-right:10px;
                        margin-left:10px;
                      }

                      @media(max-width: 736px) {
                        .mmimg_w {
                          width:100% !important;
                          height: calc(100% - 30px) !important;
                          top: 0 !important;
                          left: 0 !important;
                        }

                        .mmimg_w, .mmimg_in, .mmmimg{
                          width: 100% !important;
                          height: calc(100% - 30px) !important;
                        }

                        .mmmimg p, .mmmimg img {
                          width: 100% !important;
                          height: auto;
                        }
                      }
                  </style>
                  <div>
                    <div class="mmmimg newPopupDiv">
                      ${content==null?'':content}
                    </div> 
                    <div class="popup">
                      ${nextCloseYn=='Y'? `<input type="checkbox" id="next_close">${nextCloseDd} ${this.$t('nextCloseDdText')}`:''}
                      <input type="button" value="닫기" onClick="closeToday()" class="ct_bt01">
                    </div>  
                  </div> 
                  <script type="text/javascript">
                    function closeToday() {
                      ${nextCloseYn=='Y'? `var isNextClose = document.getElementById('next_close').checked;

                      if(isNextClose) {
                        var todayDate = new Date();
                        todayDate.setDate( todayDate.getDate() + ${nextCloseDd} );
                        document.cookie = name + "= Y" + "; path=/; expires=" + todayDate.toGMTString() + ";"
                      }
                      `:''}
                      window.close();
                    }
                  <\/script>`;
          win.document.write(htmlTag);
        }
      }
    }, 
  },
}
</script>